import {isAdListingPage, isAdAlertPage} from './helpers';

// Reset mobile filters
export function resetMobileFilters(event) {
    event.preventDefault();
    event.stopPropagation();

    document.getElementById('reset-spinner').classList.add('animate-spin-custom');

    setTimeout(function () {
        window.location.href = event.target.dataset.listingUrl;
    }, 100);
}

export function resetFilters(event) {
    const resetSpinner = document.getElementById('reset-spinner')

    if (!resetSpinner) {
        console.debug('Reset spinner not found');
        return;
    }

    resetSpinner.classList.add('animate-spin-custom');
    const target = event.target;
    window.location.href = target.dataset.listingUrl;
}

// Reset price filter fields to empty and triggers the form submission
export function initializePriceFilter(event, emptyFields = false) {
    event.preventDefault();
    event.stopPropagation();

    document.querySelector('#id_price_0').value = '';
    document.querySelector('#id_price_1').value = '';
    if (!emptyFields) {
        document.querySelector('#id_billing_period_0').checked = '';
        document.querySelector('#id_billing_period_1').checked = '';
        document.querySelector('#price_filter_validate_btn').click();
    }
}

export function validatePriceFilters(event, isMobile = false) {
    if (!isMobile) event.preventDefault();

    // Define selectors according to screen (mobile or not)
    const formSelector = isMobile ? '#mobile_filter_form' : '';
    const errorMinMessageElement = document.querySelector(`${formSelector} [data-validation-message-for="#id_price_0"]`);
    const errorMaxMessageElement = document.querySelector(`${formSelector} [data-validation-message-for="#id_price_1"]`);
    const minPriceElement = document.querySelector(`${formSelector} #id_price_0`);
    const maxPriceElement = document.querySelector(`${formSelector} #id_price_1`);

    // Parse values
    let minPriceInputValue, maxPriceInputValue; // Déclaration explicite des variables
    let minPrice = minPriceInputValue = parseInt(minPriceElement.value);
    let maxPrice = maxPriceInputValue = parseInt(maxPriceElement.value);


    // Convert NaN to 0
    if (!minPrice) minPrice = 0;
    if (!maxPrice) maxPrice = 0;

    // Reset input value
    if (!minPrice) minPriceInputValue = "";
    if (!maxPrice) maxPriceInputValue = "";

    // Update price inputs with parsed values
    minPriceElement.value = minPriceInputValue;
    maxPriceElement.value = maxPriceInputValue;

    // Price range validator
    let isValid = true;

    // Check min price
    if (minPrice < 0) {
        errorMinMessageElement.textContent = "Veuillez saisir un prix valide";
        isValid = false;
    } else {
        errorMinMessageElement.textContent = "";
    }

    // Check max price
    if (maxPrice < 0) {
        errorMaxMessageElement.textContent = "Veuillez saisir un prix valide";
        isValid = false;
    } else if (maxPrice > 0 && minPrice > maxPrice) {
        errorMaxMessageElement.textContent = "Prix maximum invalide";
        isValid = false;
    } else {
        errorMaxMessageElement.textContent = "";
    }

    // Stop other events if validation fails
    if (!isValid) {
        if (isMobile) event.preventDefault();
        event.stopImmediatePropagation();
    }
}

// Function to format the input with commas
export function formatInputWithCommas(inputValue) {
    // Remove existing commas and non-digit characters
    const cleanValue = inputValue.replace(/\D/g, '');

    // Add commas every three digits from the right
    return cleanValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

// Reset price filter fields to empty and triggers the form submission
export function initializeCategoryFilter(event) {
    event.preventDefault();
    event.stopPropagation();

    document.querySelector('#id_category_0').click();
}


function initializeFilters() {
    if (!(isAdListingPage() || isAdAlertPage())) {
        return;
    }

    document.getElementById('search-filter').addEventListener('keypress', function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();  // Prevents the parent form from being submitted automatically

            const searchValue = this.value;
            const url = this.getAttribute('data-url') + "?city_search=" + encodeURIComponent(searchValue);

            // Redirect to the specified URL with the 'city_search' parameter
            window.location.href = url;
        }
    });
    const cityPlaceholder = document.getElementById('city_selection').getAttribute('data-placeholder');
    const propertyTypePlaceholder = document.getElementById('property_type_selection').getAttribute('data-placeholder');
    const cityFilterSearchInput = document.querySelector("#city_selection input.choices__input.choices__input--cloned");
    const propertyTypeFilterSearchInput = document.querySelector("#property_type_selection input.choices__input.choices__input--cloned");
    if (cityFilterSearchInput) {
        cityFilterSearchInput.setAttribute("placeholder", cityPlaceholder);
    }
    if (propertyTypeFilterSearchInput) {
        propertyTypeFilterSearchInput.setAttribute("placeholder", propertyTypePlaceholder);
    }

    function setPricePlaceholders(containerId) {
        const priceMinInput = document.querySelector(`#${containerId} input[name='price_min']`);
        const priceMaxInput = document.querySelector(`#${containerId} input[name='price_max']`);

        if (priceMinInput) {
            priceMinInput.setAttribute("placeholder", "Min");
        }

        if (priceMaxInput) {
            priceMaxInput.setAttribute("placeholder", "Max");
        }
    }

    setPricePlaceholders("prices_filters");
    setPricePlaceholders("prices_filters_mobile");
}

initializeFilters();

// Attach listeners after any HTMX request that changes part of the DOM
document.body.addEventListener('htmx:load', function () {
    initializeFilters();
});